import { useMemo } from 'react';

import Cost from '@r1-frontend/ui-react/components/costs/Cost';
import { TCostProps } from '@r1-frontend/ui-react/components/costs/Cost/Cost';
import { SingleArrowDown } from '@r1-frontend/ui-react/components/svg/arrows';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { dayPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import * as ST from './styled';

type TDescribedCostProps = {
    previousCost?: TCostProps['children'],
    installmentPeriod?: number | null,
    isReverse?: boolean,
    isTestDrive?: boolean,
    isCredit?: boolean,
    onClick?: () => void,
    DescriptionWrapper?: (props: any) => JSX.Element,
    CostWrapper?: (props: any) => JSX.Element,

    className?: string,
} & Pick<TCostProps, 'children'>;

const   DescribedCost = ({
    children,
    previousCost,
    installmentPeriod = 1,
    isTestDrive = false,
    onClick,
    isCredit,

    DescriptionWrapper = (props) => <Paragraph4 $smaller {...props}/>,
    CostWrapper = (props) => <H4 $inline={true} $withIndent={false} {...props}/>,

    className,

    ...props
}: TDescribedCostProps) => {
    if (installmentPeriod && installmentPeriod < 1) {
        throw Error('The "installment period" property cannot be zero.');
    }

    const pluralizeDays = getPluralize(dayPluralize);

    const hasCreditProp = typeof isCredit !== 'undefined';

    const description = useMemo(() => {
        const testDriveText = <>Тест-драйв <span>на {installmentPeriod} {pluralizeDays(installmentPeriod ?? 1)}</span></>;
        if ((installmentPeriod && installmentPeriod > 1) || isCredit) {
            const installmentText = (hasCreditProp) ? 'Доступна рассрочка' : `Рассрочка ${installmentPeriod} мес.`;
            return isTestDrive ? testDriveText : installmentText;
        }

        return 'Полная стоимость';
    }, [installmentPeriod, isTestDrive, isCredit]);

    return (
        <div className={className} onClick={onClick} {...props}>
            <ST.Installment>
                <DescriptionWrapper>{description}</DescriptionWrapper>
                {!!onClick && <i><SingleArrowDown/></i>}
            </ST.Installment>
            <CostWrapper>
                <Cost isMonthly={Boolean(!hasCreditProp && installmentPeriod && installmentPeriod > 1)}>
                    {children}
                </Cost>
                {previousCost && (
                    <Paragraph4 as={'span'} $color={COLORS.TextHint} $smaller>
                        <Cost isMonthly={Boolean(installmentPeriod && installmentPeriod > 1)} isPreviously>
                            {previousCost}
                        </Cost>
                    </Paragraph4>
                )}
            </CostWrapper>
        </div>
    );
};

export default DescribedCost;
